import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumProductRoadmap } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_stacktrace/product-roadmap/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  const title = t('component.sidebar.ppForceProductRoadmap');
  useDocumentTitle(title);

  /**
   * 概要 / 設定 は未実装のため disabled。
   * `to` は LinkProps の型上必須なので未実装パスを `as never` でキャスト。
   */
  const tabs = [{
    to: '/product-roadmap/overview' as never,
    children: t('common.list.overview'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/product-roadmap',
    children: t('common.list.roadmapList'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/product-roadmap/settings' as never,
    children: t('common.list.settings'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={ProductLogoMediumProductRoadmap} name={title} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}